import { render, staticRenderFns } from "./baseOverview.vue?vue&type=template&id=305a3f6a&scoped=true"
import script from "./baseOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./baseOverview.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305a3f6a",
  null
  
)

export default component.exports